export const SURVEY_PROPS_ORDER = ['vehicleType', 'vehiclesAmount', 'routeType', 'region', 'bill', 'credit'];

export const STEPS = {
  'VEHICLE_TYPE': 1,
  'VEHICLE_NUMBER': 2,
  'ROUTE_TYPE': 3,
  'REGION': 4,
  'BILL': 5,
  'CREDIT': 6
}

export const VEHICLES_TYPES = {
  'TRUCK': 'vehicles.truck',
  'CAR': 'vehicles.car',
  'VAN': 'vehicles.van',
  'TAXI': 'vehicles.taxi',
  'MIX': 'vehicles.mix',
  'OTHER': 'vehicles.other'
}

export const VEHICLES_AMOUNT = {
  'ONE': '1',
  'TWO_FIVE': '2-5',
  'SIX_TEN': '6-10',
  'ELEVEN_MORE': '+11'
}

export const ROUTE_TYPES = {
  'INTERNATIONAL': 'routes.international',
  'NATIONAL': 'routes.national',
  'REGIONAL': 'routes.regional',
  'LAST_MILE': 'routes.last_mile'
}

export const OPTIONS = {
  'YES': 'options.yes',
  'NO': 'options.no',
  'DONNO': 'options.donno'
}

/* Spanish districts */
/*export const REGIONS = {
  'Albacete': 'baja',
  'Alicante/Alacant': 'alta',
  'Almería': 'baja',
  'Araba/Álava': 'baja',
  'Asturias': 'baja',
  'Ávila': 'baja',
  'Badajoz': 'baja',
  'Balears, Illes': 'alta',
  'Barcelona': 'alta',
  'Bizkaia': 'baja',
  'Burgos': 'baja',
  'Cáceres': 'baja',
  'Cádiz': 'baja',
  'Cantabria': 'baja',
  'Castellón/Castelló': 'baja',
  'Ciudad Real': 'baja',
  'Córdoba': 'baja',
  'Coruña, A': 'baja',
  'Cuenca': 'baja',
  'Gipuzkoa': 'baja',
  'Girona': 'baja',
  'Granada': 'baja',
  'Guadalajara': 'baja',
  'Huelva': 'baja',
  'Huesca': 'baja',
  'Jaén': 'baja',
  'León': 'baja',
  'Lleida': 'baja',
  'Lugo': 'baja',
  'Madrid': 'alta',
  'Málaga': 'baja',
  'Murcia': 'baja',
  'Navarra': 'baja',
  'Ourense': 'baja',
  'Palencia': 'baja',
  'Palmas, Las': 'alta',
  'Pontevedra': 'baja',
  'Rioja, La': 'baja',
  'Salamanca': 'baja',
  'Santa Cruz de Tenerife': 'alta',
  'Segovia': 'baja',
  'Sevilla': 'baja',
  'Soria': 'baja',
  'Tarragona': 'baja',
  'Teruel': 'baja',
  'Toledo': 'baja',
  'Valencia/València': 'alta',
  'Valladolid': 'baja',
  'Zamora': 'baja',
  'Zaragoza': 'baja',
  'Ceuta': 'baja',
  'Melilla': 'baja'
}*/

/* Portuguese districts */
export const REGIONS = {
  'Aveiro': 'alta',
  'Beja': 'baja',
  'Braga': 'alta',
  'Bragança': 'baja',
  'Castelo Branco': 'baja',
  'Coimbra': 'baja',
  'Évora': 'baja',
  'Faro': 'alta',
  'Guarda': 'baja',
  'Leiria': 'baja',
  'Lisboa': 'alta',
  'Portalegre': 'baja',
  'Porto': 'alta',
  'Santarém': 'baja',
  'Setúbal': 'alta',
  'Viana do Castelo': 'baja',
  'Vila Real': 'baja',
  'Viseu': 'baja',
}

export const CAPILLARITY = {
  'LOW': 'baja',
  'HIGH': 'alta'
}

export const RESULT_CARDS = {
  'TAXI': {
    'CARD_NAME': 'StarRessa Taxi',
    /*'URL_ES': '/transportista/recomendador/taxi',
    'URL_EN': '/carrier/recommender/taxi',*/
    'URL_PT': '/transportador/recomendacao-cartoes/taxi',
  },
  'REGIONAL': {
    'CARD_NAME': 'StarRessa (Regional)',
    /*'URL_ES': '/transportista/recomendador/regional',
    'URL_EN': '/carrier/recommender/regional',*/
    'URL_PT': '/transportador/recomendacao-cartoes/distrito',
  },
  'NATIONAL': {
    'CARD_NAME': 'StarRessa (Nacional)',
    /*'URL_ES': '/transportista/recomendador/nacional',
    'URL_EN': '/carrier/recommender/nacional',*/
    'URL_PT': '/transportador/recomendacao-cartoes/nacional',
  },
  'EUROTRAFFIC': {
    'CARD_NAME': 'StarRessa Eurotraffic',
    /*'URL_ES': '/transportista/recomendador/eurotraffic',
    'URL_EN': '/carrier/recommender/eurotraffic',*/
    'URL_PT': '/transportador/recomendacao-cartoes/eurotraffic',
  },
  'DIRECT_REGIONAL': {
    'CARD_NAME': 'StarRessa Direct (Regional)',
    /*'URL_ES': '/transportista/recomendador/direct-regional',
    'URL_EN': '/carrier/recommender/direct-regional',*/
    'URL_PT': '/transportador/recomendacao-cartoes/direct-distrito',
  },
  'DIRECT_NATIONAL': {
    'CARD_NAME': 'StarRessa Direct (Nacional)',
    /*'URL_ES': '/transportista/recomendador/direct-nacional',
    'URL_EN': '/carrier/recommender/direct-nacional',*/
    'URL_PT': '/transportador/recomendacao-cartoes/direct-nacional',
  }
}
